import { Analysis, ProbabilityCategory, PanelMarker, 
    PossibleRootCauseCategory } from '.';

export class WBCAnalysis extends Analysis {
    immuneSystemDisorderProbability?: number;
    immuneSystemDisorderProbabilityCategory?: ProbabilityCategory;

    reset() {
        super.reset()
        this.immuneSystemDisorderProbability = -1;
        this.immuneSystemDisorderProbabilityCategory = ProbabilityCategory.NA;
    }

    performAnalysis() {
        super.performAnalysis()
        this.calculateImmuneSystemDisorderProbability();
        this.calculateImmuneSystemDisorderProbabilityCategory();
        // TODO: Add this back in when ready for possible root cause categories are needed for WBC
        // this.calculateInfectionLikelyhood();
    }

    calculateImmuneSystemDisorderProbability?() {
        // 99%
        if (this.ba.wbc.isNotLab()) {
            this.immuneSystemDisorderProbability = 99;
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_11099);
            return;
        }
        // 95%  
        if (this.ba.wbc.isGreaterThanAvgMaxOrLessThanAvgMin() && this.isNotLab(this.getWBCDifferentialMarkers())) {
            this.immuneSystemDisorderProbability = 95;
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_11095);
            return;
        }
        // 93%
        if (this.ba.wbc.isGreaterThanAvgMaxOrLessThanAvgMin() && this.isGreaterThanAvgMaxOrLessThanAvgMin(this.getWBCDifferentialMarkers())) {
            this.immuneSystemDisorderProbability = 93;
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_11093);
        }

        // 91%							
        if (this.ba.wbc.isGreaterThanAvgMaxOrLessThanAvgMin() && this.isLessThanAvgMaxOrGreaterThanAvgMin(this.getWBCDifferentialMarkers())) {
            this.immuneSystemDisorderProbability = 91;
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_11091);
            return;
        }

        // 90%
        if (this.ba.wbc.isGreaterThanAvgMaxOrLessThanAvgMin() && this.isBlank(this.getWBCDifferentialMarkers())) {
            this.immuneSystemDisorderProbability = 90;
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_11090);
            return;
        }
        // 88%
        if (this.ba.wbc.isLessThanAvgMaxOrGreaterThanAvgMin() && this.isNotLab(this.getWBCDifferentialMarkers())) {
            this.immuneSystemDisorderProbability = 88;
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_11088);
            return;
        }
        // 86%
        if (this.ba.wbc.isLessThanAvgMaxOrGreaterThanAvgMin() && this.isGreaterThanAvgMaxOrLessThanAvgMin(this.getWBCDifferentialMarkers())) {
            this.immuneSystemDisorderProbability = 86;
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_11086);
            return;
        }
        // 84%
        if (this.ba.wbc.isLessThanAvgMaxOrGreaterThanAvgMin() && this.isLessThanAvgMaxOrGreaterThanAvgMin(this.getWBCDifferentialMarkers())) {
            this.immuneSystemDisorderProbability = 84;
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_11084);
            return;
        }
        // 82%
        if (this.ba.wbc.isLessThanAvgMaxOrGreaterThanAvgMin() && this.isBlank(this.getWBCDifferentialMarkers())) {
            this.immuneSystemDisorderProbability = 82;
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_11082);
            return;
        }
        // 80%
        if (this.ba.wbc.isOptimal() && this.isNotLab(this.getWBCDifferentialMarkers())) {
            this.immuneSystemDisorderProbability = 80;
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_11080);
            return;
        }
        // 78%
        if (this.ba.wbc.isOptimal() && this.isGreaterThanAvgMaxOrLessThanAvgMin(this.getWBCDifferentialMarkers())) {
            this.immuneSystemDisorderProbability = 69; // Change after the category was set.
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_11078);
            return;
        }
        // 75%
        if (this.ba.wbc.isOptimal() && this.isLessThanAvgMaxOrGreaterThanAvgMin(this.getWBCDifferentialMarkers())) {
            this.immuneSystemDisorderProbability = 69; // Change after the category was set.
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_11075);
            return;
        }
       
        if (this.ba.wbc.isOptimal() && this.isBlankOrIsOptimal(this.getWBCDifferentialMarkers())) {
            if (this.ba.globulin.isNotLab()) {
                 // 70%
                if (this.ba.alp.isLessThanLab()) {
                    this.immuneSystemDisorderProbability = 68; // Change after the category was set.
                    this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_11070);
                    return;
                }
                // 68%
                if (this.ba.alp.isLessThanOptimal()) {
                    this.immuneSystemDisorderProbability = 67; // Change after the category was set.
                    this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_11068);
                    return;
                }
                // 65%
                if (this.ba.alp.isGreaterThanOrIsOptimal() || this.ba.alp.isGreaterThanLab()) {
                    this.immuneSystemDisorderProbability = 65;
                    this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_11065);
                    return;
                }
            }
            if (this.ba.globulin.isNotOptimal()) {
                // 63%
                if (this.ba.alp.isLessThanLab()) {
                    this.immuneSystemDisorderProbability = 63;
                    this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_11063);
                    return;
                }
                // 60%
                if (this.ba.alp.isLessThanOptimal()) {
                    this.immuneSystemDisorderProbability = 60;
                    this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_11060);
                    return;
                }
                // 57%
                if (this.ba.alp.isGreaterThanOrIsOptimal() || this.ba.alp.isGreaterThanLab()) {
                    this.immuneSystemDisorderProbability = 57;
                    this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_11057);
                    return;
                }
            }
            if (this.ba.globulin.isOptimal()) {
                // 55%
                if (this.ba.alp.isLessThanLab()) {
                    this.immuneSystemDisorderProbability = 55;
                    this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_11055);
                    return;
                }
                // 50%
                if (this.ba.alp.isLessThanOptimal()) {
                    this.immuneSystemDisorderProbability = 50;
                    this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_11050);
                    return;
                }                
            }
            // 10%
            // BLANK OR >= Opt OR > Lab
            if ( (this.ba.globulin.isBlank() || this.ba.globulin.isOptimal()) && 
                 (this.ba.alp.isBlank() || this.ba.alp.isGreaterThanOrIsOptimal() || this.ba.alp.isGreaterThanLab())) {
                this.immuneSystemDisorderProbability = 10;
                this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_11010);
                return; 
            }
        }
    }

    calculateImmuneSystemDisorderProbabilityCategory?() {
        if (this.immuneSystemDisorderProbability >= 90) { // 90 - 100
            this.immuneSystemDisorderProbabilityCategory = ProbabilityCategory.HIGHLY_LIKELY;
        } else if (this.immuneSystemDisorderProbability >= 70) { // 70 - 89
            this.immuneSystemDisorderProbabilityCategory = ProbabilityCategory.LIKELY; 
        } else if (this.immuneSystemDisorderProbability >= 50) { // 50 - 69
            this.immuneSystemDisorderProbabilityCategory = ProbabilityCategory.POSSIBLE; 
        } else if (this.immuneSystemDisorderProbability >= 0) { // 0 - 49
            this.immuneSystemDisorderProbabilityCategory = ProbabilityCategory.LESS_LIKELY; 
        }
    }

    calculateInfectionLikelyhood?() {
        if (this.ba.wbc.isGreaterThanLab()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_12000);
        } else if (this.ba.wbc.isGreaterThanAvgMax()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_12005);
        } else if (this.ba.wbc.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_12010);
        } else if (this.ba.wbc.isLessThanLab()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_12015);
        } else if (this.ba.wbc.isLessThanAvgMin()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_12020);        
        } else if (this.ba.wbc.isGreaterThanAvgMax()) {
        } else if (this.ba.wbc.isStricklyLessThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_12025);
        }
    }

    isOptimal?(panelMarkers: PanelMarker[]): boolean {
        return panelMarkers.every((pm) => {
         return pm.isOptimal();
        });
     }
    
    isNotLab?(panelMarkers: PanelMarker[]): boolean {
       return panelMarkers.some((pm) => {
        return pm.isNotLab();
       });
    }

    isBlank?(panelMarkers: PanelMarker[]): boolean {
        return panelMarkers.some((pm) => {
         return pm.isBlank();
        });
     }

     isBlankOrIsOptimal?(panelMarkers: PanelMarker[]): boolean {
        return panelMarkers.every((pm) => {
         return pm.isBlank() || pm.isOptimal();
        });
     }

    isGreaterThanAvgMaxOrLessThanAvgMin?(panelMarkers: PanelMarker[]): boolean {
        return panelMarkers.some((pm) => {
            return pm.hasValue() && pm.isGreaterThanAvgMaxOrLessThanAvgMin();
        });
    }

    isLessThanAvgMaxOrGreaterThanAvgMin?(panelMarkers: PanelMarker[]): boolean {
        return panelMarkers.some((pm) => {
            return pm.hasValue() && pm.isLessThanAvgMaxOrGreaterThanAvgMin();
        });
    }

    getWBCDifferentialMarkers?(): PanelMarker[] {
        return [
            this.ba.neutrophilsAbs, this.ba.lymphocytesAbs, this.ba.monocytesAbs, this.ba.eosinophilsAbs, this.ba.basophilsAbs,
            this.ba.neutrophils, this.ba.lymphocytes, this.ba.monocytes, this.ba.eosinophils, this.ba.basophils];
    }

    calculateInsights() {
    // --- WBC Insights (section=WBC): 70001–70007 ---
    const wbc = this.ba.wbc;
    const nlr = this.ba.nlr;

    // Treat high/low using your existing semantics
    const wbcHigh = wbc.isGreaterThanLab() || wbc.isGreaterThanOptimal();
    const wbcLow  = wbc.isLessThanLab() || wbc.isStricklyLessThanOptimal();

    const hasNlr  = !!nlr && nlr.hasValue && nlr.hasValue();
    const nlrHigh = hasNlr && (nlr.isGreaterThanLab() || nlr.isGreaterThanOptimal());
    const nlrLow  = hasNlr && (nlr.isLessThanLab() || nlr.isStricklyLessThanOptimal());

    // Prefer combined WBC+NLR patterns if NLR exists
    if (hasNlr && wbcHigh && nlrHigh) {
        this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_70004); // Acute Innate
    } else if (hasNlr && wbcHigh && nlrLow) {
        this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_70005); // Acute Adaptive
    } else if (hasNlr && wbcLow && nlrHigh) {
        this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_70006); // Chronic Innate
    } else if (hasNlr && wbcLow && nlrLow) {
        this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_70007); // Chronic Adaptive
    } else {
        
    // --- WBC Insights: WBC optimal + NLR non-optimal → 70008/70009 ---
    if (this.ba.wbc.isOptimal?.() && this.ba.nlr?.hasValue?.()) {
    if (this.ba.nlr.isGreaterThanLab?.() || this.ba.nlr.isGreaterThanOptimal?.()) {
    // Innate Immune Response
    this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_70008);
    } else if (this.ba.nlr.isLessThanLab?.() || this.ba.nlr.isStricklyLessThanOptimal?.() || this.ba.nlr.isLessThanOptimal?.()) {
    // Adaptive Immune Response
    this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_70009);
    }
    } else {
    // keep your existing generic 11320/11330 pushes for cases where WBC is not optimal
    }

        // Fall back to WBC-only statuses
        if (wbcHigh) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_70002); // Acute Immune Activity
        } else if (wbcLow) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_70001); // Suppressed Immune Activity
        } else if (wbc.isOptimal() && this.immuneSystemDisorderProbability >= 50) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_70003); // Immune Abnormality (≥50%)
        }
    }

    // --- your existing insights logic (unchanged) ---
    if (this.ba.wbc.isGreaterThanOptimal()) {
        this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_11200);
    } else if (this.ba.wbc.isStricklyLessThanOptimal()) {
        this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_11210);
    }

    if (this.ba.neutrophils.isGreaterThanOptimal() || this.ba.neutrophilsAbs.isGreaterThanOptimal()) {
        this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_11220);
    } else if (this.ba.neutrophils.isStricklyLessThanOptimal() || this.ba.neutrophilsAbs.isStricklyLessThanOptimal()) {
        this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_11230);
    }

    if (this.ba.lymphocytes.isGreaterThanOptimal() || this.ba.lymphocytesAbs.isGreaterThanOptimal()) {
        this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_11240);
    } else if (this.ba.lymphocytes.isStricklyLessThanOptimal() || this.ba.lymphocytesAbs.isStricklyLessThanOptimal()) {
        this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_11250);
    }

    if (this.ba.monocytes.isGreaterThanOptimal() || this.ba.monocytesAbs.isGreaterThanOptimal()) {
        this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_11260);
    } else if (this.ba.monocytes.isStricklyLessThanOptimal() || this.ba.monocytesAbs.isStricklyLessThanOptimal()) {
        this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_11270);
    }

    if (this.ba.eosinophils.isGreaterThanOptimal() || this.ba.eosinophilsAbs.isGreaterThanOptimal()) {
        this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_11280);
    } else if (this.ba.eosinophils.isStricklyLessThanOptimal() || this.ba.eosinophilsAbs.isStricklyLessThanOptimal()) {
        this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_11290);
    }

    if (this.ba.basophils.isGreaterThanOptimal() || this.ba.basophilsAbs.isGreaterThanOptimal()) {
        this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_11300);
    } else if (this.ba.basophils.isStricklyLessThanOptimal() || this.ba.basophilsAbs.isStricklyLessThanOptimal()) {
        this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_11310);
    }

    if (this.ba.nlr.isGreaterThanOptimal()) {
        this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_11320);
    } else if (this.ba.nlr.isStricklyLessThanOptimal()) {
        this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_11330);
    }

    if (this.ba.globulin.isGreaterThanOptimal()) {
        this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_11340);
    } else if (this.ba.globulin.isStricklyLessThanOptimal()) {
        this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_11360);
    }
    }
}